var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65669 0.352518C9.2005 -0.117506 8.46502 -0.117506 8.00884 0.352518L0.272314 8.32374C-0.0907715 8.69784 -0.0907715 9.30216 0.272314 9.67626L8.00884 17.6475C8.46502 18.1175 9.2005 18.1175 9.65669 17.6475C10.1129 17.1775 10.1129 16.4197 9.65669 15.9496L2.91632 8.9952L9.666 2.04077C10.1129 1.58034 10.1129 0.81295 9.65669 0.352518Z",
    fill: "#307BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6567 0.352518C21.2005 -0.117506 20.465 -0.117506 20.0088 0.352518L12.2723 8.32374C11.9092 8.69784 11.9092 9.30216 12.2723 9.67626L20.0088 17.6475C20.465 18.1175 21.2005 18.1175 21.6567 17.6475C22.1129 17.1775 22.1129 16.4197 21.6567 15.9496L14.9163 8.9952L21.666 2.04077C22.1129 1.58034 22.1129 0.81295 21.6567 0.352518Z",
    fill: "#7EADFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.9fd736ce.svg";
export { ForwardRef as ReactComponent };